export default __webpack_public_path__ + "static/nihar_bhagat_profile-8a1a00514dd60fa562868c293bceae52.jpg";